import { apiRequest } from "../api.jsx";

export const getHomeFeed = () => apiRequest("/home");
export const getBanners = () => apiRequest("/banners?limit=6");
export const getCategories = () => apiRequest("/categories");
export const getProducts = (query = "") =>
  apiRequest(`/products${query ? `?${query}` : ""}`);
export const getProductDetail = (slug, productCode) =>
  apiRequest(`/products/${slug}/${productCode}`);
export const getProductReviews = (productId) =>
  apiRequest(`/products/${productId}/reviews`);
export const getMyProductReview = (productId) =>
  apiRequest(`/products/${productId}/reviews/me`);
export const createProductReview = (productId, review) =>
  apiRequest(`/products/${productId}/reviews`, "POST", review);
export const updateProductReview = (reviewId, review) =>
  apiRequest(`/reviews/${reviewId}`, "PATCH", review);
export const getPublicSettings = () => apiRequest("/settings");
